<template>
<footer class="site-footer">
  <div class="site-container footer-main">
    <div class="footer-brand-row">
      <router-link class="footer-logo" to="/" aria-label="GB Whata home">
        <img src="@/assets/gbwhata-home.webp" alt="GB WhatsApp logo">
      </router-link>
      <p class="footer-tagline">
        <router-link class="footer-brand-link" to="/">GB Whata</router-link> is an independent guide to GB WhatsApp APKs, privacy settings, installation, and troubleshooting.
      </p>
    </div>

    <nav aria-label="Footer site links">
      <ul class="footer-inline-links">
        <li><router-link to="/privacy/">Privacy</router-link></li>
        <li><router-link to="/disclaimer/">Disclaimer</router-link></li>
      </ul>
    </nav>

    <p class="footer-legal">
      &copy; 2026 gbwhata.io. GB WhatsApp is a third-party modification and is not affiliated with WhatsApp or Meta.
    </p>
  </div>
</footer>
</template>

<script>
export default {
  name: 'Footer',
};
</script>

<style lang="scss" scoped>
.site-footer {
  margin-top: 0;
  border-top: 1px solid var(--line);
  background: linear-gradient(180deg, #eef6f1 0%, #e4efe9 100%);
  font-family: Inter, 'Segoe UI', Tahoma, system-ui, sans-serif;
}

.footer-main {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 26px 0 22px;
  text-align: center;
}

.footer-brand-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 0.65rem;
  width: 100%;
}

.footer-logo {
  display: inline-flex;
  flex: 0 0 auto;
  width: 40px;
  height: 40px;
  align-items: center;
  justify-content: center;
  border-radius: 11px;
  background: #ffffff;
  box-shadow: var(--shadow-sm);
}

.footer-logo img {
  width: 32px;
  height: 32px;
  border-radius: 8px;
}

.footer-tagline {
  margin: 0;
  color: var(--ink-soft);
  font-size: 15px;
  line-height: 1.4;
  text-align: left;
}

.footer-brand-link {
  color: var(--ink);
  font-family: 'Plus Jakarta Sans', Inter, 'Segoe UI', sans-serif;
  font-weight: 600;
  text-decoration: underline;
  text-decoration-color: rgba(19, 37, 30, 0.28);
  text-underline-offset: 3px;
  transition: color 200ms ease, text-decoration-color 200ms ease;
}

.footer-brand-link:hover {
  color: var(--green-dark);
  text-decoration-color: currentColor;
}

.footer-inline-links {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 8px 0;
  margin: 0;
  padding: 0;
  list-style: none;
}

.footer-inline-links li {
  display: inline-flex;
  align-items: center;
}

.footer-inline-links li + li::before {
  content: '|';
  margin: 0 10px;
  color: #a8bcb0;
  font-size: 12px;
  font-weight: 400;
  user-select: none;
}

.footer-inline-links a {
  color: var(--green-dark);
  font-size: 12px;
  font-weight: 500;
  line-height: 1.3;
  text-decoration: underline;
  text-decoration-color: rgba(13, 107, 57, 0.4);
  text-underline-offset: 3px;
  transition: color 200ms ease, text-decoration-color 200ms ease;
}

.footer-inline-links a:hover {
  color: var(--green);
  text-decoration-color: currentColor;
}

.footer-legal {
  margin: 0;
  max-width: min(720px, 100%);
  color: var(--muted);
  font-size: 13.5px;
  line-height: 1.5;
}

@media (max-width: 640px) {
  .footer-brand-row {
    flex-direction: column;
    gap: 10px;
  }

  .footer-tagline {
    text-align: center;
  }
}
</style>
